import SearchBar from '../SearchBar/SearchBar';
import {
    useInitialSearch,
    useModel,
    useFirstRequestText,
    useIntegratedModels,
    useProductDetails,
    useMessages,
    usePortalInitialization,
    useInvestigationDetails
} from '../../AppContext';
import { useEffect, useMemo } from 'react';
import useAnalytics from '../../hooks/useAnalytics';
import { ANALYTICS_EVENTS } from '../../consts';
import useSwitchPanel from '../../hooks/useSwitchPanel';
import { adjustIntegratedModel } from '../../utils/productUtils';
import EclipseLoader from '../../SVG/EclipseLoader';
import FirstRequestPanelLogo from './FirstRequestPanelLogo';
import { useTranslation } from 'react-i18next';

const FirstRequestPanel = () => {
    const { model, setModelData } = useModel();
    const { productDetails, setProductDetails } = useProductDetails();
    const { integratedModels } = useIntegratedModels();
    const { setCoPilotPanel } = useSwitchPanel();
    const { setInitialSearch } = useInitialSearch();
    const { firstRequestText, setFirstRequestText, resetFirstRequestText } =
        useFirstRequestText();
    const { sendEvent } = useAnalytics();
    const { setMessages } = useMessages();
    const { isPortalInitialized, setIsPortalInitialized } =
        usePortalInitialization();
    const { setInvestigationDetails } = useInvestigationDetails();
    const { t } = useTranslation();

    useEffect(() => {
        if (!isPortalInitialized) {
            sendEvent(ANALYTICS_EVENTS.PORTAL_LOADED);
            setIsPortalInitialized(true);
        }
    }, []);

    const handleSearchSubmit = () => {
        setMessages([]);
        setInitialSearch(firstRequestText);
        setCoPilotPanel();
        resetFirstRequestText();
        setInvestigationDetails(productDetails, firstRequestText);
    };

    const onSelectedValue = (modelObject) => {
        setModelData(modelObject.modelName);
        setProductDetails(modelObject);
    };

    const selectedValue = useMemo(() => {
        if (!model || model === t('common.all')) {
            return t('common.all');
        }
        return adjustIntegratedModel({
            modelName: model,
            modelDisplay: productDetails?.modelDisplay,
            productTypeDisplay: productDetails?.productTypeDisplay,
            manufacturerDisplay: productDetails?.manufacturerDisplay,
            productTypeName: productDetails?.productTypeName,
            manufacturerName: productDetails?.manufacturerName
        });
    }, [model, productDetails, t]);

    return (
        <div className="first-request">
            <FirstRequestPanelLogo />
            {integratedModels.length ? (
                <div className="first-request__input-container">
                    <SearchBar
                        placeholder={t('search.ask')}
                        withClearButton
                        withSelect={Boolean(model)}
                        selectedValue={selectedValue}
                        setSelectedValue={onSelectedValue}
                        onSubmit={handleSearchSubmit}
                        dataTestId="first_request_search_bar"
                        disabled={!integratedModels.length}
                        value={firstRequestText}
                        setValue={setFirstRequestText}
                        growWithText={false}
                        withPresetSuggestions
                        modelAutoSelect
                    />
                </div>
            ) : (
                <div className="first-request__loader">
                    <EclipseLoader />
                </div>
            )}
        </div>
    );
};

export default FirstRequestPanel;
